import filter from "lodash/filter";
import isString from "lodash/isString";
import map from "lodash/map";
import replace from "lodash/replace";
import buildHtml from "./buildHtml";
import imgSrcToBase64 from "./imgSrcToBase64";
import isBase64Image from "./isBase64Image";
export const createHiddenElement = () => {
    const div = document.createElement("div");
    div.style.setProperty("display", "block");
    div.style.setProperty("position", "absolute");
    div.style.setProperty("box-sizing", "border-box");
    div.style.setProperty("margin", "0");
    div.style.setProperty("padding", "0");
    div.style.setProperty("visibility", "hidden");
    return div;
};
const globalHiddenElement = createHiddenElement();
export const getElementSize = (element, hiddenElement = globalHiddenElement) => {
    if (!element)
        return { width: 0, height: 0 };
    hiddenElement.appendChild(element);
    document.body.appendChild(hiddenElement);
    const width = hiddenElement.clientWidth + 1;
    const height = hiddenElement.clientHeight + 1;
    hiddenElement.removeChild(element);
    document.body.removeChild(hiddenElement);
    return {
        width,
        height
    };
};
export const getReactElementSize = (elementJSX, encodeImagesBase64 = false) => {
    if (!elementJSX)
        return Promise.resolve({ width: 0, height: 0, staticMarkup: undefined });
    const { htmlElement, htmlString } = buildHtml(elementJSX);
    const currentHiddenElement = createHiddenElement();
    let staticMarkup = htmlString;
    if (encodeImagesBase64) {
        const imgs = filter(htmlElement.querySelectorAll("img"), img => !isBase64Image(img.src));
        if (htmlElement.matches("img") && !isBase64Image(htmlElement.src))
            imgs.push(htmlElement);
        const promises = map(imgs, async (img) => {
            var _a, _b, _c;
            const attrWidth = (_a = img.attributes.getNamedItem("width")) === null || _a === void 0 ? void 0 : _a.value;
            const attrHeight = (_b = img.attributes.getNamedItem("height")) === null || _b === void 0 ? void 0 : _b.value;
            const base64 = await imgSrcToBase64(img.src, attrWidth ? parseInt(attrWidth) : undefined, attrHeight ? parseInt(attrHeight) : undefined);
            const prevSrc = (_c = img.attributes.getNamedItem("src")) === null || _c === void 0 ? void 0 : _c.value;
            if (base64 && isString(base64) && prevSrc) {
                staticMarkup = replace(staticMarkup, new RegExp(`src="${prevSrc}"`), `src="${base64}"`);
            }
        });
        return Promise.all(promises)
            .then(() => {
            const { width, height } = getElementSize(htmlElement, currentHiddenElement);
            return {
                width,
                height,
                staticMarkup
            };
        })
            .catch(() => ({
            width: 0,
            height: 0,
            staticMarkup
        }));
    }
    const { width, height } = getElementSize(htmlElement, currentHiddenElement);
    return Promise.resolve({
        width,
        height,
        staticMarkup
    });
};
